
/** 
 * Transforms a string into a human-readable phone string
 * @example `'554199998888' -> '+55 41 99999-8888'`
 */
export const prettifyPhoneString = (value: string): string => {
  if (typeof value !== 'string') return null

  const numbers1 = value
    .replace(/[^0-9]/g, '') // keep only numbers
    .slice(0, 13) // limit to 13 numbers

  const numbers = numbers1
  //  numbers1.length === 10 || numbers1.length === 11 ?
  //   // add fake placeholder country code
  //   '00' + numbers1 :
  //   numbers1;

  const countryCode = numbers.slice(0, 2)
  const areaCode = numbers.slice(2, 4)
  const phone = numbers.slice(4)
  const phoneFirstPart = phone.length === 9 ? phone.slice(0, 5) : phone.slice(0, 4)
  const phoneSecondPart = phone.length === 9 ? phone.slice(5) : phone.slice(4)

  const countryCodeStr = countryCode && countryCode !== '00' ? `+${countryCode}` : ''
  const areaCodeStr = areaCode ? ` ${areaCode}` : ''
  const phoneStr = (phoneFirstPart ? ` ${phoneFirstPart}` : '') + (phoneSecondPart ? `-${phoneSecondPart}` : '')

  return countryCodeStr + areaCodeStr + phoneStr
}

export const validateFormWhatsappNumber = (phoneString: string): boolean => {
  if (!phoneString) return false
  const numbers = phoneString.replace(/[^0-9]/g, '') // keep only numbers

  if (numbers.length === 13 || numbers.length === 12 || numbers.length === 11 || numbers.length === 10)
    return true

  return false
}
